/* ============================================================
   NB · Studio / Fit Pic Image-Mode Toggle
   ------------------------------------------------------------
   Wird auf den 4 Collections gerendert (all, grails, new-in,
   under-200-chf) und persistiert die User-Wahl in localStorage.

   Markup-Konvention:
     <div data-image-mode-toggle>
       <button data-mode="studio" class="is-active">Studio</button>
       <button data-mode="fitpic">Fit Pic</button>
     </div>

   Wirkung: setzt `body.is-fitpic-mode`. Cards mit
   `data-has-fit-pic="true"` swappen via CSS auf das Fit-Pic-Bild.
   ============================================================ */
(function () {
  'use strict';

  var STORAGE_KEY = 'nb-image-mode';

  function applyMode(mode, buttons) {
    if (mode !== 'studio' && mode !== 'fitpic') mode = 'studio';

    if (mode === 'fitpic') {
      document.body.classList.add('is-fitpic-mode');
    } else {
      document.body.classList.remove('is-fitpic-mode');
    }

    buttons.forEach(function (btn) {
      var isActive = btn.dataset.mode === mode;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function init() {
    var toggle = document.querySelector('[data-image-mode-toggle]');
    if (!toggle) return;

    var buttons = toggle.querySelectorAll('[data-mode]');
    if (!buttons.length) return;

    /* Saved Mode lesen · localStorage kann disabled sein (Private-Browsing) */
    var savedMode = 'studio';
    try {
      var stored = localStorage.getItem(STORAGE_KEY);
      if (stored === 'fitpic' || stored === 'studio') savedMode = stored;
    } catch (_) { /* silent */ }

    applyMode(savedMode, buttons);

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var mode = btn.dataset.mode;
        applyMode(mode, buttons);
        try {
          localStorage.setItem(STORAGE_KEY, mode);
        } catch (_) { /* silent · Private-Browsing etc. */ }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
